import { Application } from '../../gql/graphql';

// conisder the differences between undefined and 0. Tom thinks we should use undefined
const getApplicationId = (application?: Application) => {
  return application?.lease?.id ?? application?.installmentLoan?.id ?? application?.loan?.id ?? 0;
};

export default getApplicationId;
